import { CustomError } from './customError';

export class SessionError extends CustomError { }
